import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FormService } from "src/app/services/form.service";
import { PackageResponse } from "src/domain/client";
import { CheckboxComponent } from "../../inputs/checkbox/checkbox.component";
import { TranslateModule } from "@ngx-translate/core";
import { PackageContainerV2Component } from "../package-container-v2/package-container-v2.component";
import { PriceDiffComponent } from "../price-diff/price-diff.component";
import { PackageTitleComponent } from "../package-title/package-title.component";
import { PackageDescriptionComponent } from "../package-description/package-description.component";

@Component({
    selector: "app-checkbox-package",
    imports: [
        CheckboxComponent,
        TranslateModule,
        PackageContainerV2Component,
        PriceDiffComponent,
        PackageTitleComponent,
        PackageDescriptionComponent
    ],
    templateUrl: "./checkbox-package.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxPackageComponent {
  package = input<PackageResponse>();
  parentPackage = input<PackageResponse>();
  parentForm = input<FormGroup<any>>();

  _formService = inject(FormService);

  extraServicesParentForm(id: string): FormGroup<any> {
    return this.parentForm().get(id) as FormGroup<any>;
  }
}
